import { GeneralSettingsProps as Props } from "./GeneralSettings";
export { default } from "./GeneralSettings";

export type GeneralSettingsProps = Props;
